import { ICountry } from '@vacationtracker/shared/data/countries'

// Popular countries that should appear first
const POPULAR_COUNTRIES = ['US', 'CA', 'GB', 'AU', 'DE', 'FR', 'IT', 'ES', 'NL', 'SE', 'NO', 'DK', 'FI']

/**
 * Sorts countries with popular ones first, then alphabetically
 * @param countries Array of countries to sort
 * @returns Sorted array with popular countries first
 */
export const sortCountriesWithPopularFirst = (countries: ICountry[]): ICountry[] => {
  const popular: ICountry[] = []
  const others: ICountry[] = []

  countries.forEach(country => {
    if (POPULAR_COUNTRIES.includes(country.iso)) {
      popular.push(country)
    } else {
      others.push(country)
    }
  })

  // Sort popular countries by their order in POPULAR_COUNTRIES array
  popular.sort((a, b) => {
    const indexA = POPULAR_COUNTRIES.indexOf(a.iso)
    const indexB = POPULAR_COUNTRIES.indexOf(b.iso)
    return indexA - indexB
  })

  // Sort others alphabetically
  others.sort((a, b) => a.name.localeCompare(b.name))

  return [...popular, ...others]
}

